import { WithId } from '@common/typescript/objects/WithId';
import { Nullable } from '@common/typescript/objects/Nullable';

import { PetFile } from '@app/objects/PetFile';
import { User } from '@app/objects/User';

export enum PetConfirmedRecordType {
	WeightThreshold = 0,
	CustomActionPopup = 1,
	NoSpecialServices = 2,
}

export interface PetConfirmedRecord extends WithId {
	petId: number;
	userId: number;
	user?: User;
	time: number;
	petConfirmedRecordType: PetConfirmedRecordType;
	isMaster: boolean;
	files?: Array<PetFile>;
}

export interface PetConfirmedRecordListItem extends WithId {
	petId: number;
	petName: string;
	userId: number;
	user: Nullable<User>;
	time: number;
	petConfirmedRecordType: PetConfirmedRecordType;
	confirmationName?: string;
	confirmationMessage?: string;
	isMaster: boolean;
	files: Array<PetFile>;
}

export function getPetConfirmedRecordTypeName(type: PetConfirmedRecordType): string {
	switch (type) {
	case PetConfirmedRecordType.WeightThreshold:
		return 'Weight confirmation';

	case PetConfirmedRecordType.CustomActionPopup:
		return 'Custom Action Popup';

	case PetConfirmedRecordType.NoSpecialServices:
		return 'No special services confirmation';

	default:
		return 'Unknown confirmation';
	}
}
